export enum PAYMENT_BEHAVIOUR {
  UNKNOWN = 'unknown',
  PAYMENT_REQUIRED = 'PaymentRequired',
  NO_PAYMENT = 'NoPayment',
  PAYMENT_DEDUCTED_FROM_REFUND = 'PaymentDeductedFromRefund',
}
